<template>
    <app-page-error v-if="!canShowGameStats" />
    <div v-else class="has-background-eduloc-grey-light " style="height: calc(100vh - 5rem);">
        <project-navbar
            @information="showShareModal = true"
            :content="session.project"
        />
        <session-detail-header v-bind="session"></session-detail-header>

        <div class="section px-6 mx-6 py-0">
            <nav class="level mb-0">
                <div class="level-left">
                    <div class="level-item">
                        <div class="tabs is-left is-marginless">
                            <ul class="has-text-weight-bold">
                                <li
                                    :class="
                                        $route.query.tab == 'participants' ? 'is-active' : ''
                                    "
                                >
                                    <router-link
                                        v-t="'ranking_tab_title'"
                                        class="tab-element is-size-5 px-0 py-0 mr-5 has-text-weight-normal"
                                        :to="{
                                            name: 'session-detail',
                                            query: { tab: 'participants' },
                                        }"
                                        replace
                                    ></router-link>
                                </li>
                                <li :class="$route.query.tab == 'questions' ? 'is-active' : ''">
                                    <router-link
                                        v-t="getSectionTitle"
                                        class="tab-element is-size-5 px-0 py-0 has-text-weight-normal"
                                        :to="{
                                            name: 'session-detail',
                                            query: { tab: 'questions' },
                                        }"
                                        replace
                                    ></router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="level-right" v-if="isRankingActive">
                    <div class="level-item">
                        <app-search-bar
                            v-model="searchValue"
                            class="lb-media-search-bar"
                        />
                    </div>
                    <div class="level-item">
                        <div class="column is-narrow has-background-eduloc-red px-3 py-3 mv-0 my-0">
                            <figure class="image is-20x20 is-clickable" @click="exportToPDF">
                                <img src="@/assets/images/pdf_file_white.png">
                            </figure>
                        </div>
                    </div>
                </div>
            </nav>
            
        </div>

        <div class="section px-6 mx-6 py-0 has-scroll-y is-scroll-hidden" style="height: calc(100vh - 20rem);">
            <component
                :is="currentView"
                :questions="completeQuestions"
                :user-answers="session.session_answers"
                :isTreasurehunt="isTreasurehunt"
                :clues="completeClues"
                :content="content"
                :is-treasure-hunt="isTreasurehunt"
                :report-info="reportInfo"
                :searchValue="searchValue"
                :generatePdf="generatePdf"
                @pdfGenerated="generatePdf=false"
            ></component>
        </div>

         <project-modal-share
            v-if="showShareModal"
            :content="session.project"
            @close="showShareModal = false"
            class="project-resume"
        ></project-modal-share>
    </div>
</template>

<script>
import _ from 'underscore';
import { fetchItem } from '@/services/API';
import SessionDetailHeader from '@/components/SessionDetailHeader';
import SessionDetailPlayers from '@/components/SessionDetailPlayers';
import SessionDetailQuestionsList from '@/components/SessionDetailQuestionsList';
import AppSearchBar from '@/components/AppSearchBar';
import ProjectModalShare from '@/components/ProjectModalShare';
import ProjectNavbar from '@/components/ProjectNavbar';
import AppPageError from '@/components/AppPageError';


export default {
    components: {
        SessionDetailHeader,
        SessionDetailPlayers,
        SessionDetailQuestionsList,
        AppSearchBar,
        ProjectModalShare,
        ProjectNavbar,
        AppPageError
    },
    props: {
        _id: {
            type: String,
            default: undefined,
        },
    },
    metaInfo() {
        return {
            title: this.session.title,
            titleTemplate: '%s - eduloc360',
        };
    },
    data() {
        return {
            session: {},
            isTreasurehunt: false,
            searchValue: null,
            showShareModal: false,
            generatePdf: false
        };
    },
    computed: {
        canShowGameStats() {
            if (this.$store.getters.activePlan) {
                return this.$store.getters.activePlan.configuration.project.gameStats
            }
            return false;
        },
        isRankingActive(){
            return this.$route.query.tab!='questions';
        },
        currentView() {
            switch (this.$route.query.tab) {
                case 'questions':
                    return SessionDetailQuestionsList;
                    break;
                case 'participants':
                    return SessionDetailPlayers;
                    break;
                default:
                    return SessionDetailPlayers;
            }
        },
        groupedScores() {
            return _.groupBy(this.session.scores, (answer) => {
                return answer.object;
            });
        },
        questions() {
            let gameQuestions = [];
            if (this.session.project && this.session.project.format == 'PROJECT_TYPE_GEOQUIZ') {
                this.session.context.forEach(element => {
                    element.questions.forEach(q => { 
                        gameQuestions.push(q)
                    })
                });
            } else {
                gameQuestions = this.session.context
            }
            const totalQuestions = _.filter(
                gameQuestions,
                (question) => {
                    return question.type == 'question' || question.answers;
                }
            );
            // console.log('total questions', totalQuestions.length,gameQuestions);
            return totalQuestions;
        },
        clues() {
            const totalClues = _.filter(this.session.context, (element) => {
                //return element.triggers && element.triggers.GO_TO_POINT;
                return element.type=='clue'
            });
            //console.log("totalClues",totalClues.length)
            return totalClues;
        },
        completeQuestions() {
            return _.map(this.questions, (question) => {
                const scores = this.groupedScores[question._id] || [];
                const totalScore = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.points;
                    },
                    0
                );
                const answeredRight = _.filter(scores, (score) => {
                    return score.points > 0;
                });

                const hitRate = !scores.length
                    ? 0
                    : +((answeredRight.length / scores.length) * 100).toFixed(
                          0
                      );

                const totalTime = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.time;
                    },
                    0
                );
                /*console.log({
                    ...question,
                    ...{ scores, totalScore, hitRate, totalTime },
                });*/
                return {
                    ...question,
                    ...{ scores, totalScore, hitRate, totalTime },
                };
            });
        },
        completeClues() {
            return _.map(this.clues, (clue) => {
                const scores =
                    //this.groupedScores[clue.triggers.GO_TO_POINT] || [];
                    this.groupedScores[clue._id] || [];
                    
                const totalScore = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.points;
                    },
                    0
                );
                const reached = _.filter(scores, (score) => {
                    return score.points > 0;
                });

                const hitRate = !scores.length
                    ? 0
                    : +((reached.length / scores.length) * 100).toFixed(0);

                const totalTime = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.time;
                    },
                    0
                );
                // console.log("scores",scores,"totalScore",totalScore,"reached",reached,"hitRate",hitRate,"totalTime",totalTime)
                return {
                    ...clue,
                    ...{ scores, totalScore, hitRate, totalTime },
                };
            });
        },
        content() {
            let cluesAndQuestions = [];
            // console.log("complete clues",this.completeClues)
            if (this.session.context) {
                for (let element of this.session.context) {
                    //if (element.triggers && element.triggers.GO_TO_POINT) {
                    if (element.type == 'clue') {
                        // console.log("checking clue",element)
                        cluesAndQuestions = [
                            ...cluesAndQuestions,
                            ..._.filter(this.completeClues, (clue) => {

                                return clue._id == element._id;
                            }),
                        ];
                    } else if (element.type == 'question') {
                        cluesAndQuestions = [
                            ...cluesAndQuestions,
                            ..._.filter(this.completeQuestions, (question) => {
                                return question._id == element._id;
                            }),
                        ];
                    }
                }
            }
            return cluesAndQuestions;
            // console.log('clues & questions', cluesAndQuestions);
        },
        getSectionTitle() {
            if (!this.isTreasurehunt) {
                return this.$t('questions_tab_title');
            } else {
                return this.$t('Sessions.clues_questions_tab_title');
            }
        },
        reportInfo() {
            if (this.session && this.session.project) {
                return {
                    gameName: this.session.title,
                    projectName: this.session.project.title,
                    gameType: this.session.project.type,
                    projectFormat:this.session.project.format,
                    projectMode:this.session.project.mode,
                };
            }
        },
    },
    mounted() {
        fetchItem('session', this._id).then(({ data }) => {
            this.session = data;
            this.isTreasurehunt = this.session.project.type == 'treasurehunt';
            if(!this.$route.query.tab){
                this.$route.query.tab = 'participants'
            }
            // console.log('session answers', data);
        });
    },
    methods: {
        exportToPDF() {
            this.generatePdf = true;
        }
    }
};
</script>

<style scoped>
    @import '../assets/css/session-detail.css';
    .is-20x20{
        height: 20px;
        width: 20px;
    }
</style>
